import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';

import useAppContext from './useAppContext';

import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import EmbeddedType from 'flow/types/embedded-type';

import { androidExitApp, iosExitApp } from 'flow/actions/embedded-app-actions';
import { selectOwnExtensionKey } from 'flow/selectors/ExtensionSelectors';
import { generatePath } from 'flow/utils/router-utils';

const useSettingsNavigation = () => {
    const { embedded } = useAppContext();
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey } = useParams<{
        extensionKey: ExtensionKey;
    }>();

    const ownExtensionKey = useAppSelector(selectOwnExtensionKey);
    const isOwnSettings = ownExtensionKey === extensionKey;

    const goToSettings = () => {
        if (isOwnSettings && embedded === EmbeddedType.IOS) {
            dispatch(iosExitApp());
        } else if (isOwnSettings && embedded === EmbeddedType.ANDROID) {
            dispatch(androidExitApp());
        } else {
            history.push(generatePath(routes['settings'], { extensionKey }));
        }
    };

    return { goToSettings };
};

export default useSettingsNavigation;
